import type { Corner } from "@softmax/web-features/site";

export function readStoredCorner(storageKey: string): Corner {
  if (typeof window === "undefined") return "bottom-right";

  const stored = localStorage.getItem(storageKey);
  return stored === "top-left" ||
    stored === "top-right" ||
    stored === "bottom-left" ||
    stored === "bottom-right"
    ? stored
    : "bottom-right";
}

export function cornerForKey({
  corner,
  key,
}: Readonly<{ corner: Corner; key: string }>): Corner | null {
  switch (key) {
    case "ArrowUp":
      return corner.endsWith("left") ? "top-left" : "top-right";
    case "ArrowDown":
      return corner.endsWith("left") ? "bottom-left" : "bottom-right";
    case "ArrowLeft":
      return corner.startsWith("top") ? "top-left" : "bottom-left";
    case "ArrowRight":
      return corner.startsWith("top") ? "top-right" : "bottom-right";
    default:
      return null;
  }
}
